import React from 'react';

import { ActionsMenuItem } from '~common/react/components/SharedWidgetsActionMenu';
import { ActionBar, ActionBarButton } from '~src/common/react/components/ActionBar';
import { IPublishedConnectionDetailInfo } from '~src/ts/models/IPublishedConnectionInfo';
import { IPublishedConnectionTaskInfo } from '~src/ts/models/IPublishedConnectionTaskInfo';

import { PublishedConnectionTaskActions } from './PublishedConnectionTaskActions';

function createActionButtons(
  publishedConnectionInfo: IPublishedConnectionDetailInfo,
  done: () => void
): ReadonlyArray<ActionBarButton> {
  return [
    PublishedConnectionTaskActions.createTaskAction(publishedConnectionInfo, done)
  ];
}

export type PublishedConnectionTasksActionBarProps = Readonly<{
  clearTasks: () => void;
  onUpdateTasks: () => void;
  publishedConnectionInfo: IPublishedConnectionDetailInfo;
  selectAllTasks: () => void;
  selectedTasks: ReadonlyArray<IPublishedConnectionTaskInfo>;
}>;

export function PublishedConnectionTasksActionBar(props: PublishedConnectionTasksActionBarProps): JSX.Element {
  const { clearTasks, onUpdateTasks, publishedConnectionInfo, selectAllTasks, selectedTasks } = props;

  const actionButtons = React.useMemo(
    () => createActionButtons(publishedConnectionInfo, onUpdateTasks),
    [onUpdateTasks, publishedConnectionInfo]
  );

  const actionsMenuItems = React.useMemo(
    (): ReadonlyArray<ActionsMenuItem> => {
      return [
        selectedTasks.length === 1
          ? PublishedConnectionTaskActions.editTaskAction(selectedTasks[0], publishedConnectionInfo, onUpdateTasks)
          : PublishedConnectionTaskActions.editScheduleAction(selectedTasks, onUpdateTasks),
        PublishedConnectionTaskActions.deleteTasksAction(selectedTasks, onUpdateTasks)
      ];
    },
    [onUpdateTasks, publishedConnectionInfo, selectedTasks]
  );

  return (
    <ActionBar
      actionButtons={actionButtons}
      actionsMenuItems={actionsMenuItems}
      anyActionsAllowed={true}
      selectionSize={selectedTasks.length}
      selectAll={selectAllTasks}
      clear={clearTasks}
    />
  );
}
